import React from "react";
import { Box, HBox } from "../box/Box";
import Spacer from "../spacer/Spacer";
import { Typo } from "../text/Typo";
import { isLightColor } from "../theme/GlobalTheme";

export const Badge = ({
	label = "",
	color,
	sx,
	icon,
	variant,
	scheme,
}: {
	variant?: "outline" | "standard" | "currency";
	label: string;
	color?: string;
	sx?: React.CSSProperties;
	icon?: JSX.Element;
	scheme?: "light" | "dark";
}) => {
	if (!variant) variant = "standard";
	if (!color) {
		if (!label) label = "";
		let lbl = label?.toLowerCase()?.trim() || "";

		color = "#347bae";
		if (variant === "outline") {
			if (scheme === "light") {
				color = variant === "outline" ? "#141313" : "#f9f8f1";
			} else {
				color = variant === "outline" ? "#090819" : "#ecf9eb";
			}
		}

		if (
			lbl.indexOf("pendi") !== -1 ||
			lbl.indexOf("wait") !== -1 ||
			lbl.indexOf("norma") !== -1 ||
			lbl.indexOf("init") !== -1 ||
			lbl.indexOf("inact") !== -1 ||
			lbl.indexOf("creat") !== -1 ||
			lbl.indexOf("legac") !== -1 ||
			lbl.indexOf("creat") !== -1
		)
			color = "#848799";

		if (lbl.indexOf("acquir") !== -1) color = "#9d4889";
		if (lbl.indexOf("terminal") !== -1) color = "#dac9b2";
		if (lbl.indexOf("rule") !== -1 || lbl.indexOf("aml") !== -1) color = "#9747FF";
		if (lbl.indexOf("channel") !== -1) color = "#a9d8e9";
		if (lbl.indexOf("merchant") !== -1) color = "#626691";
		if (lbl.indexOf("report") !== -1 || lbl.indexOf("submit") !== -1) color = "#c9dcce";
		if (lbl.indexOf("client") !== -1) color = "#e2c750";
		if (lbl.indexOf("group") !== -1) color = "#6d4a69";
		if (lbl.indexOf("user") !== -1) color = "#334ae1";
		if (lbl.indexOf("individual") !== -1) color = "#bf7dc2";
		if (lbl.indexOf("submit") !== -1) color = "#ad7c52";

		if (
			lbl.indexOf("err") !== -1 ||
			lbl.indexOf("undefined") !== -1 ||
			lbl.indexOf("fail") !== -1 ||
			lbl.indexOf("damag") !== -1 ||
			lbl.indexOf("deni") !== -1 ||
			lbl.indexOf("reject") !== -1 ||
			lbl.indexOf("block") !== -1 ||
			lbl.indexOf("delet") !== -1 ||
			lbl.indexOf("disabl") !== -1
		)
			color = "#EA3568";

		if (lbl.indexOf("expir") !== -1) color = "#c234ff";

		if (lbl.indexOf("complet") !== -1 || lbl.indexOf("succes") !== -1 || lbl.indexOf("active") !== -1) color = "#4285F4";
	}

	let textColor = variant === "outline" ? color : isLightColor(color) ? "rgba(0,0,0,.9)" : "rgba(255,255,255,1)";

	if (variant === "currency") {
		color = "#413e6d";
		textColor = "#FFF";
	}

	let typo = (
		<Typo sx={{ textTransform: "capitalize", fontSize: "10px" }} variant="medium" color={textColor}>
			{label}
		</Typo>
	);

	if (label && label?.indexOf(":") !== -1) {
		const parts = label.split(":");
		for (let i = 0; i < parts.length; i++) {
			parts[i] = parts[i].trim();
			parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
			parts[i] = parts[i].replace("_", " ");
		}

		typo = (
			<>
				<Typo
					variant="text"
					style={{ textTransform: "capitalize", fontSize: "10px", color: scheme === "dark" ? "rgba(255,255,255,0.9)" : "rgba(0,0,0,0.9)" }}>
					{parts[0]}:
				</Typo>
				<Spacer size="4px" />
				<Typo variant="text" style={{ textTransform: "capitalize", fontSize: "10px", color: textColor, fontWeight: "bold" }}>
					{parts.slice(1).join(":")}
				</Typo>
			</>
		);
	} else {
		if (label?.indexOf("_") !== -1) {
			label = label.replace("_", " ");
			const parts = label?.split(" ");
			for (let i = 0; i < parts.length; i++) {
				parts[i] = parts[i].trim();
				parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
				if (parts[i].toLowerCase() === "aml") parts[i] = parts[i].toUpperCase();
			}
			label = parts.join(" ");
			typo = (
				<Typo style={{ textTransform: "capitalize", fontSize: "10px", color: textColor }} variant="medium">
					{label}
				</Typo>
			);
		}
	}

	const borderColor = scheme === "dark" ? "rgba(255,255,255,0.25)" : "rgba(0,0,0,0.15)";

	return (
		<HBox
			center
			sx={{
				backgroundColor: variant === "outline" ? "transparent" : color,
				padding: icon ? "10px 18px" : "6px 18px",
				borderRadius: "20px",
				position: "relative",
				border: variant === "outline" ? `1px solid ${borderColor}` : "none",
				...sx,
			}}>
			{icon && <Box sx={{ left: "6px", position: "absolute", top: "6px" }}>{icon}</Box>}
			{typo}
		</HBox>
	);
};
